// Página de consulta de vouchers do sorteio (sections/sorteio-vouchers.liquid).
// O cliente digita só o CPF → POST no serviço do sorteio → mostra os vouchers, o gasto e quanto falta.
// Consulta só por CPF (decisão de 08/10): por isso a resposta é mínima — sem nome e sem lista de pedidos.
// A página não calcula voucher: gasto, vouchers válidos, valor que falta e % chegam prontos da API.
//
// Contrato da API (POST data-api-url, corpo {"cpf":"12345678909"}):
//   200 {"found":false}
//   200 {"found":true,"customer":{
//         "summary":{"accumulatedSpend":1850,"validVouchers":2,"missingValue":550,"progressPct":31,"hasProcessingOrders":false},
//         "vouchers":[{"code":"0/46321","issuedAt":"2026-11-13","status":"valid|cancelled|winner","cancelledAt":"2026-12-02","cancelReason":"devolucao|cpf_excluido|admin|null"}]}}
//   (+ "test":true quando o sistema está num sorteio de teste: a página avisa que os números não valem e mostra como fase ativa)
//   400 {"error":"CPF inválido."}   429 {"error":"Muitas tentativas para este CPF. Tente de novo mais tarde."}
// Quem responde: serviço sorteios-minimal do Kurt (Cloud Run marketing-minimal, repo gerenciadorcrm), POST /api/loja/consulta.
//
// Modo teste: digitar o "CPF de teste" do editor (só o hash chega à página; precisa NÃO ser um CPF válido)
// liga, só nesta aba, a barra com clientes de exemplo (assets/sorteio-vouchers-teste.js, baixado só aí).
// Em modo teste a consulta nunca chama a API real.
(async function () {
  const root = document.getElementById('sorteio-vouchers');
  if (!root) return;

  const TEST_FLAG = 'sorteio-vouchers-teste';
  const testHash = root.dataset.testHash || '';
  // Ligado antes de ler as configurações: a barra de teste pode simular fases (datas/ganhador).
  const testMode = testHash && sessionStorage.getItem(TEST_FLAG) === testHash ? await loadTestMode() : null;
  function loadTestMode() {
    return new Promise(resolve => {
      const script = document.createElement('script');
      script.src = root.dataset.testSrc;
      script.onload = () => resolve(window.SorteioVouchersTeste.start(root, () => {
        sessionStorage.removeItem(TEST_FLAG);
        location.reload();
      }));
      script.onerror = () => {
        console.error('Sorteio: não foi possível carregar o modo teste.');
        resolve(null);
      };
      document.head.appendChild(script);
    });
  }
  async function sha256Hex(text) {
    const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(text));
    return [...new Uint8Array(digest)].map(byte => byte.toString(16).padStart(2, '0')).join('');
  }

  const PHASES = {
    embreve: {label: 'EM BREVE', cls: ''},
    ativo: {label: 'ATIVO', cls: 'ativo'},
    apuracao: {label: 'EM APURAÇÃO', cls: ''},
    encerrado: {label: 'ENCERRADO', cls: ''}
  };
  const SUGGESTED_PRODUCTS_LIMIT = 4;
  // Reserva: se a foto de um produto falhar ao carregar, ele é trocado pelo próximo (mesma regra de preço).
  const SUGGESTED_PRODUCTS_RESERVE = 4;
  // "Aumente suas chances" (automático): só produto/kit com preço ≥ valor que falta — sozinho garante o voucher.
  // Primeiro os mais vendidos de (falta) até (falta + PRICE_BAND); se faltar produto, os mais baratos acima disso.
  // Faixa curta de propósito: quando falta pouco, entram os itens baratos (meia, cueca) em vez das camisetas campeãs.
  const PRICE_BAND = 50;
  const CANCEL_REASONS = {devolucao: 'Cancelado por devolução', cpf_excluido: 'CPF não participa (regulamento)', admin: 'Cancelado'};
  const UNAVAILABLE = 'Não foi possível consultar agora. Tente novamente em alguns minutos.';

  // ---------- configuração (settings da seção) ----------
  function parseBrDate(text) {
    const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec((text || '').trim());
    return match ? `${match[3]}-${match[2]}-${match[1]}` : '';
  }
  const raffle = {
    name: root.dataset.name,
    start: parseBrDate(root.dataset.start),
    end: parseBrDate(root.dataset.end),
    draw: (root.dataset.draw || '').trim(),
    minimum: Number(root.dataset.minimum) || 800,
    winner: (root.dataset.winner || '').trim(),
    rulesUrl: root.dataset.rulesUrl,
    supportUrl: root.dataset.supportUrl,
    apiUrl: (root.dataset.apiUrl || '').trim(),
    shopUrl: root.dataset.shopUrl || '/'
  };

  // Hoje no fuso da loja (America/Sao_Paulo), como AAAA-MM-DD.
  function today() {
    return new Intl.DateTimeFormat('en-CA', {timeZone: 'America/Sao_Paulo'}).format(new Date());
  }
  function currentPhase() {
    if (raffle.winner) return 'encerrado';
    if (raffle.end && today() > raffle.end) return 'apuracao';
    if (raffle.start && today() < raffle.start) return 'embreve';
    return 'ativo';
  }
  const phase = currentPhase();

  // ---------- formatação ----------
  const formatBrl = value => Number(value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'});
  function formatDate(isoDate) {
    const [year, month, day] = isoDate.slice(0, 10).split('-');
    return `${day}/${month}/${year}`;
  }
  const onlyDigits = text => text.replace(/\D/g, '');
  const formatCpf = digits => digits.replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d)/, '$1.$2').replace(/(\d{3})(\d{1,2})$/, '$1-$2');
  // Dígitos verificadores do CPF — evita consulta com CPF digitado errado.
  function isValidCpf(digits) {
    if (!/^\d{11}$/.test(digits) || /^(\d)\1{10}$/.test(digits)) return false;
    const checkDigit = length => {
      let sum = 0;
      for (let i = 0; i < length; i++) sum += Number(digits[i]) * (length + 1 - i);
      const rest = (sum * 10) % 11;
      return rest === 10 ? 0 : rest;
    };
    return checkDigit(9) === Number(digits[9]) && checkDigit(10) === Number(digits[10]);
  }
  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, char => ({'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[char]));
  }

  // ---------- textos por fase ----------
  function periodText() {
    if (raffle.start && raffle.end) return `de ${formatDate(raffle.start).slice(0, 5)} a ${formatDate(raffle.end)}`;
    if (raffle.start) return `a partir de ${formatDate(raffle.start)}`;
    return 'no período do sorteio';
  }
  function drawText() {
    return raffle.draw ? `Sorteio em ${raffle.draw}.` : 'Data do sorteio a definir.';
  }
  function describePhase() {
    const perVoucher = `a cada ${formatBrl(raffle.minimum)} você ganha 1 voucher`;
    if (phase === 'embreve') return `A coleta de números começa em ${formatDate(raffle.start)} · ${perVoucher}`;
    if (phase === 'apuracao') return `Período de compras encerrado · ${drawText()}`;
    if (phase === 'encerrado') return raffle.draw ? `Resultado do sorteio de ${raffle.draw}` : 'Resultado do sorteio';
    return `Compras ${periodText()} · ${perVoucher}`;
  }

  function renderHeader() {
    const badge = root.querySelector('[data-sv-phase]');
    badge.textContent = PHASES[phase].label;
    badge.className = `sv-phase ${PHASES[phase].cls}`;
    root.querySelector('[data-sv-sub]').textContent = describePhase();
    const links = [];
    if (raffle.rulesUrl) links.push(`<a href="${escapeHtml(raffle.rulesUrl)}" target="_blank" rel="noopener">Regulamento do sorteio</a>`);
    if (raffle.supportUrl) links.push(`<a href="${escapeHtml(raffle.supportUrl)}" target="_blank" rel="noopener">Dúvidas? Fale com nosso atendimento</a>`);
    root.querySelector('[data-sv-foot]').innerHTML = links.join(' · ');
  }

  // ---------- consulta ----------
  let currentCustomer; // undefined = sem consulta; null = CPF sem compra no período
  let currentTab = 'vouchers';

  async function fetchCustomer(cpf) {
    if (testMode) return testMode.fetchCustomer(cpf);
    if (!raffle.apiUrl) throw new Error(UNAVAILABLE);
    let response;
    try {
      response = await fetch(raffle.apiUrl, {
        method: 'POST',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({cpf})
      });
    } catch (error) {
      console.error('Sorteio: falha de rede na consulta de vouchers.', error);
      throw new Error(UNAVAILABLE);
    }
    const body = await response.json().catch(() => null);
    if (response.status === 429) throw new Error((body && body.error) || 'Muitas consultas. Tente de novo em 15 minutos.');
    if (response.status === 400 && body && body.error) throw new Error(body.error);
    if (!response.ok || !body) {
      console.error(`Sorteio: consulta respondeu ${response.status}.`, body);
      throw new Error(UNAVAILABLE);
    }
    return body.found ? {...body.customer, test: body.test === true} : null;
  }

  function showError(text) {
    const box = root.querySelector('[data-sv-error]');
    box.textContent = text;
    box.hidden = !text;
  }

  async function consultCpf(event) {
    event.preventDefault();
    const digits = onlyDigits(root.querySelector('#sv-cpf').value);
    // CPF de teste: nunca um CPF válido (um cliente real jamais cai aqui) e confere pelo hash.
    if (testHash && !testMode && digits.length === 11 && !isValidCpf(digits) && await sha256Hex(digits) === testHash) {
      sessionStorage.setItem(TEST_FLAG, testHash);
      location.reload();
      return;
    }
    if (!isValidCpf(digits)) { showError('CPF inválido. Confira os 11 números.'); return; }
    showError('');
    const button = root.querySelector('[data-sv-form] button');
    button.disabled = true;
    root.querySelector('[data-sv-result]').innerHTML = '<p class="sv-loading">Consultando…</p>';
    currentTab = 'vouchers';
    try {
      currentCustomer = await fetchCustomer(digits);
    } catch (error) {
      currentCustomer = undefined;
      showError(error.message);
    } finally {
      button.disabled = false;
    }
    renderResult();
  }

  // ---------- resultado ----------
  function renderHowItWorks() {
    return `<div class="sv-how"><div class="sv-sec-title" style="margin-top:0">Como funciona</div>
      <ol class="sv-steps">
        <li><i>1</i><div><b>Compre no site</b>Compras ${periodText()}, informando seu CPF no checkout.</div></li>
        <li><i>2</i><div><b>A cada ${formatBrl(raffle.minimum)}, 1 voucher</b>O valor soma todos os seus pedidos no mesmo CPF.</div></li>
        <li><i>3</i><div><b>Concorra pela Loteria Federal</b>${drawText()}</div></li>
      </ol>
      <p class="sv-muted">Já comprou? Consulte pelo CPF. O voucher aparece em até 24 horas depois do pagamento aprovado.</p>
      ${phase === 'ativo' || phase === 'embreve' ? `<a class="sv-btn" href="${escapeHtml(raffle.shopUrl)}">Ir para a loja</a>` : ''}</div>`;
  }

  function renderVoucherList(vouchers) {
    return vouchers.map(voucher => {
      if (voucher.status === 'cancelled') {
        const when = voucher.cancelledAt ? ` em ${formatDate(voucher.cancelledAt)}` : '';
        const reason = CANCEL_REASONS[voucher.cancelReason] || 'Cancelado';
        return `<div class="sv-voucher cancel"><div><code>${escapeHtml(voucher.code)}</code><small>${reason}${when}</small></div><span class="sv-pill bad">Cancelado</span></div>`;
      }
      const isWinner = voucher.status === 'winner' || (phase === 'encerrado' && voucher.code === raffle.winner);
      const pill = isWinner ? '<span class="sv-pill accent">🏆 Ganhador</span>' : '<span class="sv-pill ok">Válido</span>';
      return `<div class="sv-voucher ${isWinner ? 'win' : ''}"><div><code>${escapeHtml(voucher.code)}</code><small>Emitido em ${formatDate(voucher.issuedAt)}</small></div>${pill}</div>`;
    }).join('');
  }

  function renderPhaseNotice() {
    if (phase === 'encerrado') {
      return `<div class="sv-msg info" style="margin-bottom:12px"><b>Voucher ganhador: ${escapeHtml(raffle.winner)}</b>Extração da Loteria Federal${raffle.draw ? ` de ${escapeHtml(raffle.draw)}` : ''}.</div>`;
    }
    if (phase === 'apuracao') {
      return `<div class="sv-msg warn" style="margin-bottom:12px"><b>Período de compras encerrado</b>${drawText()} Seus vouchers abaixo estão concorrendo.</div>`;
    }
    return '';
  }

  function renderResult() {
    const box = root.querySelector('[data-sv-result]');
    if (currentCustomer === undefined) { box.innerHTML = renderHowItWorks(); return; }
    if (currentCustomer === null) {
      box.innerHTML = `<div class="sv-msg bad" style="margin-bottom:18px"><b>Não encontramos compras para este CPF no período</b>Confira se digitou o mesmo CPF informado no checkout. Comprou hoje? O voucher aparece em até 24 horas.</div>${renderHowItWorks()}`;
      return;
    }
    const customer = currentCustomer;
    const summary = customer.summary;
    const hello = '<div class="sv-hello">Seus vouchers neste sorteio</div>';
    if (customer.vouchers.length === 0 && summary.hasProcessingOrders) {
      box.innerHTML = `${hello}<div class="sv-msg warn"><b>Seu voucher ainda está sendo gerado</b>Se você comprou há pouco, ele aparece aqui em até 24 horas.</div>`;
      return;
    }
    // Sorteio de teste (antes da coleta real): mostra como ativo, com aviso de que os números não valem.
    const isActive = phase === 'ativo' || customer.test;
    const testNotice = customer.test
      ? '<div class="sv-msg warn" style="margin-bottom:12px"><b>Ambiente de teste</b>Estes números são de um teste interno e não valem para o sorteio.</div>'
      : '';
    let html = `${hello}${testNotice}<div class="sv-stats">
        <div class="sv-stat"><span>Gasto no período</span><strong>${formatBrl(summary.accumulatedSpend)}</strong></div>
        <div class="sv-stat"><span>Vouchers válidos</span><strong>${summary.validVouchers}</strong></div>
        <div class="sv-stat desk-only"><span>${isActive ? 'Falta p/ o próximo' : 'Vouchers emitidos'}</span><strong>${isActive ? formatBrl(summary.missingValue) : customer.vouchers.length}</strong></div>
      </div>${customer.test ? '' : renderPhaseNotice()}`;
    if (isActive) {
      const title = summary.validVouchers === 0 ? 'Seu 1º voucher' : 'Próximo voucher';
      html += `<div class="sv-progress"><b>${title}</b>
          <span class="bar"><i style="width:${Math.min(Math.max(summary.progressPct, 0), 100)}%"></i></span>
          <small>Faltam ${formatBrl(summary.missingValue)} · a cada ${formatBrl(raffle.minimum)} você ganha 1 voucher</small></div>
        <div class="sv-tabs">
          <button type="button" data-tab="vouchers" class="${currentTab === 'vouchers' ? 'on' : ''}">Meus vouchers</button>
          <button type="button" data-tab="chances" class="${currentTab === 'chances' ? 'on' : ''}">Aumente suas chances</button>
        </div>`;
    }
    html += '<div data-sv-tab-body></div>';
    box.innerHTML = html;

    const tabBody = box.querySelector('[data-sv-tab-body]');
    if (isActive && currentTab === 'chances') {
      renderProducts(summary.missingValue, tabBody);
    } else {
      const vouchers = customer.vouchers.length
        ? `<div class="sv-voucher-list">${renderVoucherList(customer.vouchers)}</div>`
        : '<p class="sv-muted" style="font-size:13px">Você ainda não tem vouchers neste sorteio.</p>';
      tabBody.innerHTML = `<div class="sv-sec-title">Seus vouchers</div>${vouchers}`;
    }
    box.querySelectorAll('.sv-tabs button').forEach(button => button.addEventListener('click', () => {
      currentTab = button.dataset.tab;
      renderResult();
    }));
  }

  // ---------- "Aumente suas chances": produtos da própria loja ----------
  // A loja filtra pela faixa de preço e ordena (Section Rendering API em /collections/all).
  async function loadProducts(sortBy, minPrice, maxPrice) {
    const params = new URLSearchParams({section_id: 'sorteio-sugestoes', sort_by: sortBy, 'filter.v.price.gte': String(Math.floor(minPrice))});
    if (maxPrice) params.set('filter.v.price.lte', String(Math.ceil(maxPrice)));
    const response = await fetch(`${raffle.shopUrl.replace(/\/$/, '')}/collections/all?${params}`);
    if (!response.ok) throw new Error(`Sugestões: /collections/all respondeu ${response.status}.`);
    const html = await response.text();
    const script = new DOMParser().parseFromString(html, 'text/html').querySelector('script[data-sorteio-sugestoes]');
    if (!script) throw new Error('Sugestões: resposta sem o bloco data-sorteio-sugestoes.');
    return JSON.parse(script.textContent);
  }
  // Preço exibido: a variante disponível mais barata que sozinha cobre o que falta (nunca abaixo).
  function coveringPrice(product, missingValue) {
    const prices = product.variants
      .filter(([cents, available]) => available && cents / 100 >= missingValue)
      .map(([cents]) => cents / 100);
    return prices.length ? Math.min(...prices) : null;
  }
  // Devolve os 4 da vitrine + reservas, em ordem. Produto sem foto não entra.
  async function fetchSuggestions(missingValue) {
    const max = SUGGESTED_PRODUCTS_LIMIT + SUGGESTED_PRODUCTS_RESERVE;
    const picked = [];
    const add = products => products.forEach(product => {
      const price = coveringPrice(product, missingValue);
      if (price === null || !product.image || picked.length >= max || picked.some(item => item.url === product.url)) return;
      picked.push({...product, price});
    });
    add(await loadProducts('best-selling', missingValue, missingValue + PRICE_BAND));
    if (picked.length < max) add(await loadProducts('price-ascending', missingValue + PRICE_BAND));
    return picked;
  }

  async function renderProducts(missingValue, container) {
    container.innerHTML = '<p class="sv-loading">Carregando produtos…</p>';
    let products = [];
    try {
      products = await fetchSuggestions(missingValue);
    } catch (error) {
      console.error(error);
    }
    const showShopLink = () => {
      container.innerHTML = `<div class="sv-msg info"><b>Faltam ${formatBrl(missingValue)} para seu próximo voucher</b>Monte seu pedido na loja: a cada ${formatBrl(raffle.minimum)} você ganha 1 voucher.</div>
        <a class="sv-btn" style="margin-top:14px" href="${escapeHtml(raffle.shopUrl)}">Ir para a loja</a>`;
    };
    if (!products.length) { showShopLink(); return; }
    container.innerHTML = `<div class="sv-msg info" style="margin-bottom:12px"><b>Faltam ${formatBrl(missingValue)} para seu próximo voucher</b>Qualquer um destes garante mais 1 voucher:</div>
      <div class="sv-products"></div>`;
    const grid = container.querySelector('.sv-products');
    const reserve = products.slice(SUGGESTED_PRODUCTS_LIMIT);
    const onEmpty = () => { if (!grid.children.length) showShopLink(); };
    products.slice(0, SUGGESTED_PRODUCTS_LIMIT).forEach(product => grid.appendChild(productCard(product, reserve, onEmpty)));
  }

  // Card de produto. Foto quebrada → troca pelo próximo da reserva; sem reserva, o card sai
  // (e, se não sobrar nenhum, aparece o botão da loja).
  function productCard(product, reserve, onEmpty) {
    const utm = 'utm_source=sorteio-minimal&utm_medium=aumente-chances';
    const card = document.createElement('a');
    card.className = 'sv-product';
    card.href = `${product.url}${product.url.includes('?') ? '&' : '?'}${utm}`;
    card.innerHTML = `<span class="img"><img alt="" loading="lazy"></span>
      <span class="info"><b>${escapeHtml(product.title)}</b><span>${formatBrl(product.price)}</span><em>✓ +1 voucher</em></span>`;
    const image = card.querySelector('img');
    image.addEventListener('error', () => {
      const next = reserve.shift();
      if (next) { card.replaceWith(productCard(next, reserve, onEmpty)); return; }
      card.remove();
      onEmpty();
    }, {once: true});
    image.src = product.image;
    return card;
  }

  // ---------- início ----------
  const cpfInput = root.querySelector('#sv-cpf');
  cpfInput.addEventListener('input', () => {
    cpfInput.value = formatCpf(onlyDigits(cpfInput.value).slice(0, 11));
  });
  root.querySelector('[data-sv-form]').addEventListener('submit', consultCpf);
  renderHeader();
  renderResult();
})();
